<template>
  <VisaForm country="korea" :products>
    <template #visa_select="{ form }">
      <BasketFields :form :products />
      <EntryFields v-model="form.entry" />
      <TermsCheckbox v-model="form.termsAgreed" />
    </template>

    <template #details="{ form }">
      <PassportDetailsNotes half-year-valid />
      <ClientFields v-model="form.client" />
      <AppRow>
        <StayAddress v-model="form.stayAddress" required />
      </AppRow>
      <ApplicantInfo
        v-for="(applicant, i) in form.applicants"
        :applicant="applicant"
        :index="i"
      >
        <template #passport>
          <PassportFields v-model="applicant.passport" />
        </template>
        <template #personal>
          <ExtraNationalityFields v-model="applicant.extraNationality" />
          <CityOfBirth v-model="applicant.cityOfBirth" />
          <AddressFields v-model="applicant.address" />
          <OccupationFields v-model="applicant.occupation" has-phone />
          <FormBlock>
            <EverVisitedRadio v-model="applicant.visited" />
          </FormBlock>
          <LastTravelFields v-model="applicant.lastTravel" />
          <CrimeFields v-model="applicant.crime" />
        </template>
      </ApplicantInfo>

      <AppAlert icon="mdi:child-toy" class="mb-3">
        {{ $tt('korea_accompanying_children_info') }}
      </AppAlert>
      <AccompanyingChildrenFields v-model="form.children" />
    </template>

    <template #review />
    <template #upload />
    <template #payment />
  </VisaForm>
</template>

<script setup lang="ts">
import type { Product } from '~/types';

defineProps<{
  products: Product[];
}>();
</script>